<ng-container *ngIf="role !== undefined || name !== undefined">
   <p> Role: <i>{{name}}: {{role}}</i> </p>
</ng-container>